// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails =
/** @class */
function () {
  function ExceptionDetails() {
    this.hasFullStack = true;
    this.parsedStack = [];
  }

  return ExceptionDetails;
}();

export { ExceptionDetails };